import { render, staticRenderFns } from "./ManageBranches.vue?vue&type=template&id=4d4c5661&scoped=true"
import script from "./ManageBranches.vue?vue&type=script&lang=js"
export * from "./ManageBranches.vue?vue&type=script&lang=js"
import style0 from "./ManageBranches.vue?vue&type=style&index=0&id=4d4c5661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c5661",
  null
  
)

export default component.exports